/**
 * Piletilevi report-api services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * - EVENT_OWNER - Access events when owner centre matches logged in centre. Shows tickets and revenues. - VENUE_OWNER - Access events when venue owner legal person matches logged in centre legal person. Shows only tickets without \'reporting_venue_owner_show_revenue\' 
 */
export type OwnerType = 'EVENT_OWNER' | 'VENUE_OWNER';

export const OwnerType = {
    EventOwner: 'EVENT_OWNER' as OwnerType,
    VenueOwner: 'VENUE_OWNER' as OwnerType
};

